import { Component } from '@opten/compiler/metadata/component';
import * as packery from 'packery';
import * as getSize from 'get-size';

import getSelectorElementFromElement from '@opten/dom/get-selector-element-from-element';
import getAnimationEndEventName from '@opten/animation/get-animation-end-event-name';
import getParentWithClass from '@opten/dom/get-parent-with-class';
import getTransitionProperty from '@opten/animation/get-transition-property';
import scrollToElement from '@opten/scroll/scroll-to-element';

import removeClass from '@opten/dom/remove-class';
import addClass from '@opten/dom/add-class';
import hasClass from '@opten/dom/has-class';

@Component({ className: 'js-isotope' })
export class Isotope {
	private container: HTMLElement;
	private filters: HTMLElement[];
	private items: HTMLElement[];
	private links: HTMLElement[];

	private instance: packery;

	private options = {
		itemSelector: '.js-isotope-item',
		layout: 'packery',
		percentPosition: true,
		packery: {
			gutter: 30,
		},
	};

	constructor(private element: HTMLElement) {
		this.container = element.querySelector('.js-isotope-container');
		this.filters = Array.from(element.querySelectorAll('.js-isotope-filter'));
		this.items = Array.from(element.querySelectorAll('.js-isotope-item'));
		this.links = Array.from(element.querySelectorAll('.js-isotope-item [aria-expanded]'));

		this.init();
	}

	private init() {
		this.instance = new packery(this.container, this.options);

		this.filters.forEach((filter) => filter.addEventListener('click', () => this.filter(filter)));
		this.links.forEach((item) => item.addEventListener('click', (event: MouseEvent) => this.toggle(item, event)));

		setTimeout(() => {
			this.items.forEach(item => this.instance.fit(item));
			this.instance.shiftLayout();
		}, 2000);

		if (window.location.hash) {
			const filter = window.location.hash.substr(1, window.location.hash.length);
			const el = document.querySelector(`[data-filter=".${filter}"]`) as HTMLElement;
			if (el) {
				this.filter(el);
				scrollToElement(el, undefined, 300, -100);
			}
		}
	}

	private toggle(item: HTMLElement, event: MouseEvent) {
		const isExpanded = (item.getAttribute('aria-expanded') === 'true');
		const content = getSelectorElementFromElement(item, 'href');
		const card = getParentWithClass(item, 'js-isotope-item');

		const visibleContentSize = this.setItemContentPixelSize(content);
		console.log('item size:', visibleContentSize);

		// renable default transition
		content.style[getTransitionProperty()] = '';

		this.addTransitionListener(content);
		this.setItemContentTransitionSize(content, isExpanded ? visibleContentSize.height : 0);

		console.log('card height:', card.offsetHeight, visibleContentSize.height);
		if (isExpanded) {
			this.instance.fit(card);
		} else {
			this.instance.shiftLayout();
		}
	}

	private filter(filter: HTMLElement) {
		if (hasClass(filter, 'is--active') === false) {
			const value = filter.getAttribute('data-filter');

			this.items.forEach((item) => {
				if (value === '*' || hasClass(item, value.substr(1))) {
					removeClass(item, 'd-none');
				} else {
					addClass(item, 'd-none');
				}
			});

			this.filters.forEach((item) => removeClass(item, 'is--active'));
			addClass(filter, 'is--active');
			setTimeout(() => {
				this.instance.shiftLayout();
			}, 100);
		}
	}

	private setItemContentPixelSize(content: HTMLElement) {
		const previousContentSize = getSize(content);

		// disable transition
		content.style[getTransitionProperty()] = 'none';

		// show content to get size
		content.style.display = 'block';
		const visibleContentSize = getSize(content);

		// reset display property
		content.style.display = '';

		// set current size in pixels
		content.style.height = previousContentSize.height + 'px';
		console.log('previous', previousContentSize.height);

		return visibleContentSize;
	}

	private addTransitionListener(content: HTMLElement) {
		// reset 100%/100% sizing after transition end
		const onTransitionEnd = () => {
			content.style.height = '';
			content.removeEventListener(getAnimationEndEventName().toString(), onTransitionEnd );
		};
		content.addEventListener(getAnimationEndEventName().toString(), onTransitionEnd );
	}

	private setItemContentTransitionSize(content: HTMLElement, height: any) {
		// set new size
		console.log('1', content.style.height, content.offsetHeight)
		content.style.height = height + 'px';
		console.log('2', content.style.height, content.offsetHeight)
	}
}

